import * as React from "react";
import { quoteSippIncomePaymentDetailsLabels, quoteSippIncomePaymentDetailsMessages } from "../../../Resource/Content";
import RegularIncomePayment from "../../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import IncomeRequired from "../../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownAnnualIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import { processTypeEnum } from "../../../../Common/Resource/Contents";
import { PensionBase } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import IncomeFromPension from "./IncomeFromPension";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";

interface IIncomePaymentProps extends IProcessComponentProps {
    data: DrawdownAnnualIncome;
    onChange: (changes) => void;
    pensionBase: PensionBase;
    isITFC: boolean;
}
interface IIncomePaymentState { }

export class IncomePayment extends ProcessComponent<IIncomePaymentProps, IIncomePaymentState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data, onChange, pensionBase, isITFC } = this.props;

        return (
            <div>
                <IncomeRequired
                    data={data}
                    onChange={onChange}
                    labels={quoteSippIncomePaymentDetailsLabels}
                    messages={quoteSippIncomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={pensionBase?.DrawdownModel?.DrawdownType}
                    pensionTransfer={pensionBase?.PensionTransfers}
                    processType={processTypeEnum.Quote}
                    regularCrystalDifferentInital={
                        pensionBase?.DrawdownModel?.RegularCrystallisationDetails?.HasADifferentInitialAmount
                    }
                    regularCrystallisationDetails={pensionBase?.DrawdownModel?.RegularCrystallisationDetails}
                    pensionBase={pensionBase}
                    isITFC={isITFC}
                />
                <RegularIncomePayment
                    data={data}
                    onChange={onChange}
                    labels={quoteSippIncomePaymentDetailsLabels}
                    messages={quoteSippIncomePaymentDetailsMessages}
                    onRef={(ref) => this.appendChild(ref)}
                    drawdownType={pensionBase?.DrawdownModel?.DrawdownType}
                    availableCash={pensionBase?.DrawdownModel?.CrystallisationDetails?.AvailableCash?.Amount}
                    taxFreeLumpSum={pensionBase?.DrawdownModel?.TaxFreeLumpSum?.Amount}
                    regularCrystallisationDetails={pensionBase?.DrawdownModel?.RegularCrystallisationDetails}
                    shouldHidePaymentMethod={true}
                    pensionBase={pensionBase}
                    processType={processTypeEnum.Quote}
                    isITFC={isITFC}
                />
            </div>
        );
    }
}

export default IncomePayment;
